<template>
  <div class="GeneralConditionEquipmentItemWrap">
    <div class="lists-item-wrap">
      <p class="GeneralCondition__title">{{ title }}</p>
      <div class="item" v-for="item in lists" :key="item.name">
        <p class="count">{{ item.value }}</p>
        <!-- <p class="name">{{ item.name }}</p> -->
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'GeneralConditionEquipmentItemWrap',
  props: {
    lists: {
      type: Array,
      default: () => []
    },
    title: {
      type: String,
      default: ''
    }
  },
  data () {
    return {

    }
  },
  computed: {

  },
  created () {

  },
  mounted () {

  },
  watch: {

  },
  methods: {

  }

}
</script>

<style scoped lang="stylus">
.GeneralConditionEquipmentItemWrap
  font-size: .8rem
  margin-bottom 1rem
  .GeneralCondition__title
    color: #00E8BD
    font-size: .8rem
    flex-shrink: 0
    flex-basis: 24%
  .count
    margin-bottom: .25rem
    color: #fff
  .name
    font-size: .8rem
    color: rgba(255, 255, 255, 0.6);

.lists-item-wrap
  display flex
  justify-content space-between
  .item
    text-align: center
    flex-basis: 19%
    height: 1rem
</style>
